import React, { useEffect, useState } from "react";
import { GET_AUDIT_BY_MOBILE_NO } from "../../constants";
import axios from "axios";
import {
  Card,
  CardContent,
  Chip,
  Typography,
  Divider,
  Box,
} from "@mui/material";
import moment from "moment";
import StarIcon from "@mui/icons-material/Star";
import { styled } from "@mui/system"; // Import the styled API from @mui/system

// Styled components using @mui/system
const StyledCard = styled(Card)({
  marginBottom: "20px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  borderRadius: "12px",
});

const CardHeader = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "10px",
});

const StatusChip = styled(Chip)(({ theme, actionType }) => ({
  fontWeight: "bold",
  padding: "8px 12px",
  borderRadius: "16px",
  background: actionType === "open" ? "rgb(16, 204, 82)" : "rgb(204, 16, 82)",
  color: "#fff",
  textTransform: "capitalize",
  marginBottom: "5px",
}));

const DateText = styled("div")({
  fontSize: "14px",
  fontWeight: 600,
  color: "#444",
});

const Title = styled(Typography)({
  marginBottom: "10px",
  fontSize: "16px",
  fontWeight: "500",
});

const Content = styled("div")({
  whiteSpace: "normal",
  wordWrap: "break-word",
  overflowWrap: "break-word",
});

function ExistingDataShowComponent({
  FormMobileNo,
  setTypeOfUser,
  setAuditLotNum,
  setAuditName,
  setAuditZone,
}) {
  const [timelineData, setTimelineData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLotByMobNo = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${GET_AUDIT_BY_MOBILE_NO}/${FormMobileNo}`
      );
      const { success, data } = response.data;

      if (success) {
        const { customer_status, latest_status, existing_customer } = data;

        console.log(customer_status.latest_status.type === "existing");

        if (customer_status?.latest_status?.type === "existing") {
          setTypeOfUser("running"); // Set userType to running for existing customers
        } else if (customer_status?.latest_status?.type === "old") {
          setTypeOfUser("old"); // Set userType to new for new customers
        } else {
          setTypeOfUser("new"); // Set userType to old otherwise
        }

        // Set timeline data if available
        if (
          existing_customer?.records &&
          existing_customer.records.length > 0
        ) {
          const recordsWithRemarks = existing_customer.records.map((record) => {
            // Extract remarks from the record
            const remarks = record.AuditRemarks || [];
            return { ...record, remarks };
          });
         
          setAuditLotNum(existing_customer.records[0].Lot_Number);
          setAuditZone(existing_customer.records[0].Zone_Name);
          setAuditName(existing_customer.records[0].Farmer_Name);
          setTimelineData(recordsWithRemarks);
        } else {
          setTimelineData([]);
          setAuditLotNum("");
          setAuditZone("");
          setAuditName("");
          console.log("No records found for the customer.");
        }
      } else {
        console.log("Error in fetching data.");
      }
    } catch (error) {
      if (
        error.response.data.message ===
        "No records found for this mobile number"
      ) {
        setTypeOfUser("new");
        setAuditLotNum("");
        setAuditZone("");
        setAuditName("");
      }
      console.error("Error fetching initial data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (FormMobileNo !== "") {
      fetchLotByMobNo();
    }
  }, [FormMobileNo]);

  const formatDate = (date) => {
    return moment(date).format("MMMM D, YYYY, h:mm A");
  };

  // console.log(timelineData[0].remarks_summary, "-------------");

  return (
    <>
      {loading ? (
        <div>Loading...</div>
      ) : timelineData.length > 0 ? (
        timelineData.map((log, index) => (
          <StyledCard key={index}>
            <CardContent>
              <CardHeader>
                <DateText>
                  <strong>Last Action Date: &nbsp;</strong>
                  {log.last_action_date
                    ? formatDate(log.last_action_date)
                    : "-"}
                </DateText>
                <StarIcon
                  sx={{
                    backgroundColor: "rgb(16, 204, 82)",
                    color: "#fff",
                    borderRadius: "50%",
                    padding: "5px",
                  }}
                />
              </CardHeader>

              <StatusChip label={log.status} actionType={log.status} />

              <Title variant="h5">
                <strong>Farmer Name:&nbsp;</strong>
                <strong>{log.Farmer_Name}</strong>
              </Title>
              <Divider />

              <Content>
                <strong>Lot Number:</strong> {log.Lot_Number}
                <br />
                <strong>Branch Name:</strong> {log.Branch_Name}
                <br />
                <strong>Farmer Name:</strong> {log.Farmer_Name}
                <br />
                <strong>Zone Name:</strong> {log.Zone_Name}
              </Content>

              {/* Displaying remarks */}
              <div>
                <strong>Remark updated by:</strong>
                {log.AuditRemarks && log.AuditRemarks.length > 0 ? (
                  <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                    {log.AuditRemarks.map((remark, idx) => (
                      <li
                        key={remark.id || idx}
                        style={{ marginBottom: "10px" }}
                      >
                        <strong>{remark.Agent?.EmployeeName}</strong> (
                        {remark.createdAt
                          ? formatDate(remark.createdAt)
                          : "N/A"}
                        ) - {remark.REMARKS || "No Remarks"}
                        <br />
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No remarks available.</p>
                )}
              </div>
            </CardContent>
          </StyledCard>
        ))
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100%"
          padding={2}
          sx={{
            border: "1px dashed #ccc",
            borderRadius: "8px",
            backgroundColor: "#f9f9f9",
            color: "#666",
            textAlign: "center",
          }}
        >
          <Typography variant="h6" sx={{ marginBottom: 1, color: "#444" }}>
            No Existing Records
          </Typography>
          <Typography variant="body2">
            We couldn't find any records to display at the moment.
          </Typography>
          <Box mt={2}>
            {/* <img
              src="https://via.placeholder.com/150"
              alt="No Records"
              style={{ width: "100px", height: "100px", opacity: 0.7 }}
            /> */}
          </Box>
        </Box>
      )}
    </>
  );
}

export default ExistingDataShowComponent;
